const indexComponent = require('./routes/index/components/InstallationDeviceSlavesShow');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: ':idSlave',
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/replace'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationDeviceSlavesShow'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/configuration/routes/devices/routes/show/routes/slaves/routes/show/index.js